function MobileMenuIcon(props) {
  const { slideMenu, activeCategories, all } = props;

  const activeCats = activeCategories;
  const objValues = Object.values(activeCats).flat();

  return (
    <>
      <button type='button' className='mobmenu-container' onClick={slideMenu}>
        <img
          className='mobmenu'
          src='../../img/menu-burger.svg'
          alt='mobile menu icon'
        ></img>
      </button>
      <span
        className={
          objValues.includes(all) && objValues[0] === all
            ? 'filters'
            : 'filters show'
        }
      >
        {objValues.length}
      </span>
    </>
  );
}

export default MobileMenuIcon;
